<template>
  <icon-base
    :title="title"
    :name="name"
    :viewbox="viewBox">
    



<g>
	<path d="M12,15.003c-2.895,0-5.25-2.355-5.25-5.25c0-2.895,2.355-5.25,5.25-5.25c2.895,0,5.25,2.355,5.25,5.25
		C17.25,12.648,14.895,15.003,12,15.003z M12,6.003c-2.068,0-3.75,1.682-3.75,3.75s1.682,3.75,3.75,3.75
		c2.068,0,3.75-1.682,3.75-3.75S14.068,6.003,12,6.003z"/>
	<path d="M11.999,23.901c-0.261,0-0.518-0.068-0.743-0.197c-0.875-0.5-3.126-1.911-5.142-4.209c-2.564-2.922-3.864-6.2-3.864-9.743
		c0-5.376,4.374-9.75,9.75-9.75s9.75,4.374,9.75,9.75c0,3.544-1.3,6.822-3.865,9.744c-2.017,2.299-4.268,3.708-5.142,4.208
		C12.518,23.833,12.26,23.901,11.999,23.901z M12,1.503c-4.549,0-8.25,3.701-8.25,8.25c0,1.861,0.595,8.272,8.25,12.649
		c7.655-4.372,8.25-10.787,8.25-12.649C20.25,5.204,16.549,1.503,12,1.503z"/>
</g>


  </icon-base>
</template>

<script>
import IconBase from '../IconBase';

export default {
  components: {
    IconBase,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: 'style-two-pin-marker',
    },
    name: {
      type: String,
      required: false,
      default: 'StyleTwoPinMarker',
    },
    viewBox: {
      type: String,
      required: false,
      default: '0 0 24 24',
    },
  },
};
</script>

<style scoped>
  
</style>